import { IUserProfile } from './AuthenticationSystem';

const powerUserType = 'pwrUser';
const adminUserType = 'adminUser';
const standardUserType = 'stdUser';
const directiveUserType = 'executive';
const talHumUserType = 'talHum';
const liqUserType = 'liqUser';
const adminTTSType = 'adminTTS';

export class UserProfile {
  protected constructor(private id: string, private name: string, private type: string) {}

  static fromIUserProfile(profile: IUserProfile) {
    return new this(profile.per_id, profile.per_nombre, profile.per_nemotecnico);
  }

  isNamed(aName: string) {
    return this.name === aName;
  }

  isStandardUser(): boolean {
    return this.type === standardUserType;
  }

  isDirectiveUser(): boolean {
    return this.type === directiveUserType;
  }

  isPowerUser(): boolean {
    return this.type === powerUserType;
  }

  isAdminUser(): boolean {
    return this.type === adminUserType;
  }

  isTalHumUser(): boolean {
    return this.type === talHumUserType;
  }

  isLiquidatorUser(): boolean {
    return this.type === liqUserType;
  }

  isAdminTTS(): boolean {
    return this.type === adminTTSType;
  }

  getName(): string {
    return this.name;
  }

  getId(): string {
    return this.id;
  }
}
